/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import _ from 'lodash';
import { Control, Errors } from 'react-redux-form';
import Tooltip from '../../Tooltip';
import './styles.css';
import SuitabilityRadioButtonGroup from './SuitabilityRadioButtonGroup';
import SuitabilityDropdown from './SuitabilityDrowdown';
import { SuitabilityInvestmentExperienceDisplayField, SuitabilityInvestmentExperienceEditableField } from './SuitabilityInvestmentExperience';
import { SuitabilityInvestmentObjectiveDisplayField, SuitabilityInvestmentObjectiveEditableField } from './SuitabilityInvestmentObjective';
import disclaimerImage from '../../../assets/images/informationVector.svg';

/**
 * The edittable component to be rendered on the form's edit mode
 * @param {*} props The properties to be passed on to the edittable component
 */
const EditableField = (props) => {
  switch (props.inputType) {
    case 'text':
      return (<Control.text styleName="suitabilityControl" {...props} />);
    case 'select':
      return (<SuitabilityDropdown {...props} />);
    case 'radio':
      return (<SuitabilityRadioButtonGroup {...props} />);
    case 'customInvestmentExperience':
      return (<SuitabilityInvestmentExperienceEditableField {...props} />);
    case 'customInvestmentObjective':
      return (<SuitabilityInvestmentObjectiveEditableField {...props} />);
    default:
      return ('');
  }
};

/**
 * The displayable component to be rendered on form's static mode
 * @param {*} param The properties to be passed on to the displayable component
 */
const DisplayField = (props) => {
  switch (props.inputType) {
    case 'customInvestmentExperience':
      return (<SuitabilityInvestmentExperienceDisplayField {...props} />);
    case 'customInvestmentObjective':
      return (<SuitabilityInvestmentObjectiveDisplayField {...props} />);
    default:
      return (<div styleName="staticField">{ props.display || props.defaultValue }</div>);
  }
};

const DisclaimerInformation = disclaimer => (
  <div styleName="disclaimerInfo">
    <img src={disclaimerImage} alt="info" styleName="disclaimerImage" />
    <div styleName="disclaimerText">{ disclaimer }</div>
  </div>
);

const SuitabilityFieldRow = (props, tooltipValue, componentValue, isEdit) => {
  if (props.inputType === 'customInvestmentExperience' || props.inputType === 'customInvestmentObjective') { return componentValue; }
  return (
    <div styleName="suitabilityInfo">
      <div styleName="fieldRow">
        <div>{props.label}{tooltipValue}</div>
        { props.inputType !== 'radio' || props.editMode === 'static' ? componentValue : ('') }
      </div>
      { props.inputType === 'radio' && props.editMode === 'editting' ? componentValue : ('') }
      { isEdit ? (
        <Errors
          styleName="errorText"
          show={field => field.touched || field.submitted}
          model={props.model}
          {...props.errorHandler}
        />) :
        ('')
      }
      { isEdit && !_.isEmpty(props.disclaimer) ? DisclaimerInformation(props.disclaimer) : ('') }
    </div>
  );
};

const Component = (props) => {
  const {
    editMode,
    isPartialEdit,
    tooltip,
  } = props;
  let componentValue;
  const tooltipValue = !_.isEmpty(tooltip) ? (<Tooltip styles={{ display: 'inline-block', marginLeft: '8px' }} text={tooltip} />) : ('');

  switch (editMode === 'editting' && isPartialEdit) {
    case true:
      componentValue = (<EditableField {...props} />);
      return SuitabilityFieldRow(props, tooltipValue, componentValue, true);
    default:
      componentValue = (<DisplayField {...props} />);
      return SuitabilityFieldRow(props, tooltipValue, componentValue, false);
  }
};

Component.displayName = 'SuitabilityInputRow';

export default Component;



// WEBPACK FOOTER //
// ./src/components/Forms/Suitability/SuitabilityInputRow.js